import { useClientConfig } from "src/client-config/useClientConfig.ts";
import { AppVariation } from "src/client-config/getClientConfig.ts";

export const useIsDemoShop = () => {
  const config = useClientConfig();
  return config.appVariation === AppVariation.B2bGateDemo;
};
